import { apiRequest } from "./common";

const createMileStone = async (data) => {
    const response = await apiRequest('post', '/project-milestone', data);
    return response.data;
};

const updateMileStone = async (id, data) => {
    const response = await apiRequest('put', `/project-milestone/${id}`, data);
    return response.data;
};

const updateMileStoneStatus = async (id, data) => {
    const response = await apiRequest('patch', `/project-milestone/${id}/status`, data);
    return response.data;
};

const deleteMileStone = async (id) => {
    const response = await apiRequest('delete', `/project-milestone/${id}`);
    return response.data;
};

const getMileStone = async (projectId) => {
    const response = await apiRequest('get', `/project-milestone/project/${projectId}`);
    return response.data;
};

export {
    createMileStone,
    updateMileStone,
    updateMileStoneStatus,
    deleteMileStone,
    getMileStone
}